import React from 'react';
import PropTypes from 'prop-types';

const DynamicContactInfoElement = props => (
  <div className={props.classes}>
    {props.elements}
  </div>
);

DynamicContactInfoElement.PropTypes = {
  classes:PropTypes.string,
  elements:PropTypes.array.isRequired,
};

export default DynamicContactInfoElement;
